import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import { ErrorResponse } from '@components/pages/Organization/types';
import {
  CorporateSubscriptionResponse,
  UpdateCorporateSubscriptionParams,
  updateCorporateSubscription,
} from '@utils/backend-api/corporateSubscriptions';
import {
  ACTIVE_USERS_KEY,
  ARCHIVED_USERS_KEY,
  ORGANIZATION_DETAILS_KEY,
} from '@utils/backend-api/organizations';

const useCorporateSubscriptionUpdate = () => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, data, isLoading } = useMutation(
    (params: UpdateCorporateSubscriptionParams) => updateCorporateSubscription(params),
    {
      onSuccess: ({ message }: CorporateSubscriptionResponse) => {
        toast.success(message);

        queryClient.invalidateQueries([ORGANIZATION_DETAILS_KEY]);
        queryClient.invalidateQueries([ACTIVE_USERS_KEY]);
        queryClient.invalidateQueries([ARCHIVED_USERS_KEY]);
      },
      onError: (e: ErrorResponse) => {
        toast.error(e.message);
      },
    }
  );

  return { mutate, mutateAsync, data, isLoading };
};

export default useCorporateSubscriptionUpdate;
